import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconSimBlocked({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<g fill="none" fillRule="nonzero">
				<g fill="#FEFEFE">
					<path d="M12.164 5.744H7.718c-.736 0-1.333.596-1.333 1.332v5.233c0 .736.597 1.333 1.333 1.333h4.446c.736 0 1.332-.597 1.332-1.333V7.076c0-.736-.596-1.332-1.332-1.332m-4.446.885h4.446c.247 0 .447.2.447.447v5.233c0 .248-.2.448-.447.448H7.718a.45.45 0 0 1-.448-.448V7.076c0-.247.2-.447.448-.447" />
					<path d="M13.875 3.633c.792 0 1.407.705 1.426 1.554v8.239a.442.442 0 0 1-.884.024V5.226c0-.395-.247-.693-.52-.708H6.059c-.275 0-.528.287-.54.677l-.001.03v12.576l2.772 2.632h5.585c.23 0 .45-.204.519-.513l.006-.031a.442.442 0 1 1 .87.16c-.131.712-.683 1.25-1.359 1.268H7.937l-3.304-3.136V5.225c0-.852.603-1.57 1.39-1.592h7.852" />
					<path d="M4.755 17.686a.44.44 0 0 1 .607-.033l.018.017 3.038 2.884a.442.442 0 0 1-.59.659l-.02-.017-3.037-2.884a.44.44 0 0 1-.016-.626" />
				</g>
				<path
					fill="#E42822"
					d="M14.536 14.985a.44.44 0 0 1 .607-.018l.019.018 2.81 2.811a.442.442 0 0 1-.606.644l-.019-.018-2.81-2.811a.44.44 0 0 1 0-.626"
				/>
				<path
					fill="#E42822"
					d="M17.347 14.985a.442.442 0 0 1 .643.607l-.017.019-2.811 2.81a.442.442 0 0 1-.644-.606l.018-.019z"
				/>
				<path
					fill="#E42822"
					d="M16.281 12.687a4.016 4.016 0 1 0 0 8.032 4.016 4.016 0 0 0 0-8.032m0 .885a3.131 3.131 0 1 1 0 6.263 3.131 3.131 0 0 1 0-6.263"
				/>
			</g>
		</svg>
	);
}
